export * as data from './index';
